import CardStack from '@shared/components/core/card/CardStack';
import { useTranslation } from 'react-i18next';
import OrgLinks from './OrgLinks';

interface IOrgInvitesCardProps {
    orgId: string;
}

export default function OrgProfilesCard({ orgId }: IOrgInvitesCardProps) {
    const { t } = useTranslation();

    if (!orgId) return null;
    return (
        <CardStack
            name="purchaseOrder"
            title={t('common:organization.profiles.title')}
            description={t('common:organization.profiles.description')}>
            <OrgLinks variant="orgProfiles" organizationId={orgId} />
        </CardStack>
    );
}
